export default __webpack_public_path__ + "static/BANDEJA_POLLO-18ba57e3050c91b027767e9b97de6623.jpg";